export var AttributionMode;
(function (AttributionMode) {
    AttributionMode["RETURN"] = "return";
    AttributionMode["RISK"] = "risk";
})(AttributionMode || (AttributionMode = {}));
